export default __webpack_public_path__ + "static/media/slider-gun.545410af.svg";